import { render, staticRenderFns } from "./MyTravellers.vue?vue&type=template&id=cd27445c&scoped=true&"
import script from "./MyTravellers.vue?vue&type=script&lang=js&"
export * from "./MyTravellers.vue?vue&type=script&lang=js&"
import style0 from "./MyTravellers.vue?vue&type=style&index=0&id=cd27445c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd27445c",
  null
  
)

export default component.exports